/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Stat_MinutesInputs */

const en_us2_search_stat_minutes = /** @type {(inputs: Search_Stat_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutes`)
};

const pt_br2_search_stat_minutes = /** @type {(inputs: Search_Stat_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutos`)
};

const es_419_search_stat_minutes = /** @type {(inputs: Search_Stat_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutos`)
};

const pt_pt2_search_stat_minutes = /** @type {(inputs: Search_Stat_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutos`)
};

const fr_fr2_search_stat_minutes = /** @type {(inputs: Search_Stat_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minutes`)
};

const de_de2_search_stat_minutes = /** @type {(inputs: Search_Stat_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuten`)
};

const it_it2_search_stat_minutes = /** @type {(inputs: Search_Stat_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`minuti`)
};

/**
* | output |
* | --- |
* | "minutes" |
*
* @param {Search_Stat_MinutesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_stat_minutes = /** @type {((inputs?: Search_Stat_MinutesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Stat_MinutesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_stat_minutes(inputs)
	if (locale === "es-419") return es_419_search_stat_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_search_stat_minutes(inputs)
	if (locale === "fr-FR") return fr_fr2_search_stat_minutes(inputs)
	if (locale === "de-DE") return de_de2_search_stat_minutes(inputs)
	if (locale === "it-IT") return it_it2_search_stat_minutes(inputs)
	return en_us2_search_stat_minutes(inputs)
});
export { search_stat_minutes as "search.stat_minutes" }